import React, { useRef, useState } from 'react';
import SearchSuggest from './SearchSuggest';

export default function SearchBar({ onSearch, onPickBook, onViewAll }) {
  const [value, setValue] = useState('');
  const [open, setOpen] = useState(false);
  const barRef = useRef(null);

  const submit = (e) => {
    e.preventDefault();
    onSearch?.(value.trim());
    setValue('');
    setOpen(false);
  };

  return (
    <>
      <form
        ref={barRef}
        onSubmit={submit}
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          maxWidth: 600,
          borderRadius: 999,
          overflow: 'hidden',
          height: 42,
          background: '#fff',
          boxShadow: '0 0 0 1px #cbd5e1 inset',
        }}
      >
        <input
          type="text"
          placeholder="Знайти книгу"
          value={value}
          onChange={(e) => { setValue(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          style={{
            flex: 1,
            border: 'none',
            outline: 'none',
            fontSize: 15,
            background: 'transparent',
            padding: '0 12px',
          }}
        />

        <button
          type="submit"
          style={{
            background: '#16a34a',
            color: '#fff',
            border: 'none',
            padding: '0 22px',
            fontWeight: 600,
            fontSize: 15,
            cursor: 'pointer',
            height: '100%',
          }}
        >
          Пошук
        </button>
      </form>

      {open && (
        <SearchSuggest
          anchorRef={barRef}
          search={value}
          onPick={(book) => { onPickBook?.(book); setValue(''); setOpen(false); }}
          onViewAll={(q) => { onViewAll?.(q); setOpen(false); }}
          onClose={() => setOpen(false)}
          maxItems={8}
        />
      )}
    </>
  );
}
